'use client';

import React, { memo, useMemo } from 'react';


interface AppLogoProps {
  src?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
}

const AppLogo = memo(function AppLogo({
  size = 64,
  className = '',
  onClick,
}: AppLogoProps) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  const iconSize = Math.round(size * 0.75);

  return (
    <div className={containerClassName} onClick={onClick}>
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* House shape */}
        <path d="M20 4L4 16V36H16V26H24V36H36V16L20 4Z" fill="url(#logoGrad)" />
        {/* Door */}
        <rect x="16" y="26" width="8" height="10" rx="1" fill="white" fillOpacity="0.3" />
        {/* Window */}
        <rect x="12" y="18" width="6" height="5" rx="1" fill="white" fillOpacity="0.5" />
        <rect x="22" y="18" width="6" height="5" rx="1" fill="white" fillOpacity="0.5" />
        <defs>
          <linearGradient id="logoGrad" x1="4" y1="4" x2="36" y2="36" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#1d4ed8" />
            <stop offset="100%" stopColor="#16a34a" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
});

export default AppLogo;
